<div class="not-found-container">
	<h1 class="mb-32" [cmLocalize]="locFeature + '/_Shared.NotFound.Content.NotFound'">Not Found</h1>
	<button mat-button (click)="goBack()">
		<ats-icon name="back" [size]="12"></ats-icon>
		<span [cmLocalize]="locFeature + '/_Shared.NotFound.Button.GoBack'">
			Go Back
		</span>
	</button>
</div>
